<template>
  <div class="app-wrapper">
    <!-- :style="{ transform: autoScale ? transformScale : 'scale(1)' }" -->
    <app-header />
    <!-- <div class="clearfix" /> -->
    <div class="main-container">
      <app-main />
    </div>
  </div>
</template>

<script>
import { AppMain, AppHeader } from './components'
import ResizeMixin from '../mixin/ResizeHandler'

export default {
  name: 'FullLayout',
  components: {
    AppMain,
    AppHeader
  },
  mixins: [ResizeMixin],
  data() {
    return {
      autoScale: true,
      transformScale: 'scale(1)'
    }
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation
        // mobile: this.device === 'mobile'
      }
    }
  },
  mounted() {
    // window.addEventListener("resize", this.autoSetScale());
  },
  destroyed() {
    // window.removeEventListener("resize", this.autoSetScale());
  },
  methods: {
    // 自动缩放屏幕比例
    autoSetScale() {
      // const h = window.innerHeight < 768 ? 768 : window.innerHeight
      const w = window.innerWidth < 1366 ? 1366 : window.innerWidth
      // const h_zoom = (h / 1080).toFixed(3)
      const w_zoom = (w / 1920).toFixed(3)
      // const zoom = h_zoom < w_zoom ? h_zoom : w_zoom
      this.transformScale = `scale(${w_zoom})`
      console.log(this.transformScale)
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
.app-wrapper {
  @include clearfix;
  flex-direction: column;
  // width: 100%;
  width:vw(1920);
  // height: 100%;
  height: vh(1080);
  min-width: $minWidth;
  background: #063866;
  display: flex;
  flex-direction: column;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
  .main-container {
    min-height: calc(100% - $headerHeight);
    flex: 1;
    // height: 100%;
    width: 100%;
    margin-left: 0;
    transition: margin-left 0.28s;
    min-width: $minWidth;
    display: flex;
    flex-direction: column;
    color: #ffffff;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
